<template>
  <div>
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />
    <v-card min-height="40vh">
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
        >{{ title }}
      </v-col>
      <v-col cols="12" md="12">
        <p class="text-caption">
          Our goal as an organization is to be the kind of provider we would want for 
          our loved ones. Therefore, it is vital that each employee be physically, mentally, 
          and emotionally fit to perform the duties of his or her job, which will, in turn, be
          important to our efforts to maintain high standards of care for the individuals we serve.
        </p>
        <p class="text-caption">
          To assist employees in making certain they are physically, mentally, and emotionally fit
          to perform all aspects of their job effectively, and to maintain compliance with state
          labor laws, the 18/6 Rule must be adhered to as follows:
        </p>
        <p class="text-caption">
          Employees cannot exceed 18 consecutive hours of direct care work and must have at least
          6 hours of time off following an 18-hour shift prior to the beginning another shift.
          Employees who prepare weekly work schedule must make certain each schedule is prepared
          in compliance with this rule.
        </p>
         <p class="text-caption">
         <b> By signing below, I acknowledge that I have read, understand, and agree to adhere to the
         18/6 Rule as outlined.  </b>
        </p>

        
      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="item.employeeName"
              label="Employee Name (print)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
              label="Signature"
              @click.stop="showSignaturePad = true"
              ></v-text-field>
              <v-img
                    width="150"
                    height="50"
                    :src="employeeSignature"
                    style="position:absolute;top:10px;right:150px;"
                  ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateSigned"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="dateSigned"
                @input="dateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row align="center" justify="end">
              <v-card-actions>
                <v-btn @click="next">Next</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>
<script>
/* eslint-disable */
import SignaturePad from "@/components/SignaturePad";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import download from "downloadjs";

export default {
  components: { SignaturePad },
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function() {
    return {
      dateMenu: false,
      showSignaturePad: false,
      item: {},
      step: this.currentStep,
    };
  },

  created() {
    this.populateUserInfo();
  },

  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),
   signatureData(data) {
      this.employeeSignature = data;
    },

    next() {
      this.addItem();
      localStorage.setItem('employeeSignature', this.employeeSignature);
      localStorage.setItem('dateSigned', this.dateSigned);
      
      // this.generatePDF();
      this.$emit("clicked", this.step + 1);
    },


    async addItem() {
      try {
        const response = await this.addDocument({
          data: { ...this.item, Employee: this.user._id },
          pdfDocument: "client-transportation-agreement",
        });
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {
      const dateSignedForEmployee = localStorage.getItem('dateSigned');

      if (dateSignedForEmployee !== null) {
         this.dateSigned= dateSignedForEmployee;
      }


      if (localStorage.getItem('employeeSignature')) {
        this.employeeSignature = localStorage.getItem('employeeSignature');
      }
      
    
      this.item.employeeName = this.user.Name;
      const response = await this.getDocuments(this.user._id);

      let documents = this.updateCase(
        response.data.document.Documents.ClientTransportationAgreement
      );

      this.item = Object.assign(
        {},
        {
          ...documents,
          employeeName:response.data.document.Employee.Name,
        }
      );
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "client-transportation-agreement",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(
        pdfFile,
        "client-transportation-agreement.pdf",
        "application/pdf"
      );
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}
</style>
